/**
 * Cult Everyday PDP — buy box, gallery and FAQ interactivity.
 * No dependencies. Progressive enhancement over a real <form action="/cart/add">.
 */
(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace('{{amount}}', value).replace('{{ amount }}', value);
  }

  function initBuyBox(root) {
    var variantsJson = root.querySelector('[data-cult-product-variants]');
    if (!variantsJson) return;

    var variants = JSON.parse(variantsJson.textContent || '[]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var form = root.querySelector('.cult-buy-form');
    var variantIdInput = root.querySelector('[data-cult-variant-id]');
    var priceEl = root.querySelector('[data-cult-price]');
    var comparePriceEl = root.querySelector('[data-cult-compare-price]');
    var saveBadgeEl = root.querySelector('[data-cult-save-badge]');
    var addLabelPrice = root.querySelector('[data-cult-add-price]');
    var addButton = root.querySelector('[data-cult-add-to-cart]');
    var qtyInput = root.querySelector('[data-cult-qty-input]');
    var tierRadios = root.querySelectorAll('input[name="tier"]');
    var galleryMain = root.querySelector('[data-cult-gallery-main]');
    var galleryThumbs = root.querySelectorAll('[data-cult-thumb]');
    var galleryDots = root.querySelectorAll('[data-cult-dot]');
    var freeShippingPerkEl = root.querySelector('[data-cult-free-shipping-perk]');
    var regionNoticeEl = root.querySelector('[data-cult-region-notice]');
    var currentImageIndex = 0;

    function isTrulyOutOfStock(variant) {
      return variant.inventory_policy !== 'continue' && (variant.inventory_quantity === null || variant.inventory_quantity === undefined || variant.inventory_quantity <= 0);
    }

    function setGalleryImage(index) {
      if (!galleryThumbs.length) return;
      currentImageIndex = ((index % galleryThumbs.length) + galleryThumbs.length) % galleryThumbs.length;
      var src = galleryThumbs[currentImageIndex].getAttribute('data-cult-thumb');
      if (galleryMain && src) {
        var img = galleryMain.querySelector('img');
        if (img) img.src = src;
      }
      galleryDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentImageIndex);
      });
    }

    var initialVariant = variants.filter(function (v) { return v.id === parseInt(variantIdInput.value, 10); })[0] || variants[0];

    function findVariantById(id) {
      return variants.filter(function (v) { return v.id === id; })[0];
    }

    function updateUI(variant) {
      if (!variant) return;
      variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);
      if (addLabelPrice) addLabelPrice.textContent = money(variant.price, moneyFormat);

      var hasCompareAt = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (comparePriceEl) {
        comparePriceEl.hidden = !hasCompareAt;
        if (hasCompareAt) comparePriceEl.textContent = money(variant.compare_at_price, moneyFormat);
      }
      if (saveBadgeEl) {
        saveBadgeEl.hidden = !hasCompareAt;
        if (hasCompareAt) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveBadgeEl.textContent = 'SAVE ' + pct + '%';
        }
      }

      var tierIndex = variants.indexOf(variant) + 1;
      if (freeShippingPerkEl) freeShippingPerkEl.hidden = tierIndex < 2;

      if (addButton) {
        var addLabelEl = addButton.querySelector('[data-cult-add-label]');
        if (variant.available) {
          addButton.disabled = false;
          addLabelEl.textContent = 'Add to Cart';
          if (regionNoticeEl) regionNoticeEl.hidden = true;
        } else {
          var trulyOutOfStock = isTrulyOutOfStock(variant);
          addButton.disabled = true;
          addLabelEl.textContent = trulyOutOfStock ? 'Sold Out' : 'Not Available in Your Region';
          if (regionNoticeEl) regionNoticeEl.hidden = trulyOutOfStock;
        }
      }

      if (variant.featured_image && galleryMain) {
        var img = galleryMain.querySelector('img');
        if (img) img.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
        currentImageIndex = 0;
        galleryDots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === 0);
        });
      }
    }

    tierRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var variant = findVariantById(parseInt(radio.value, 10));
        updateUI(variant || initialVariant);
      });
    });

    if (qtyInput) {
      var decrease = root.querySelector('[data-cult-qty-decrease]');
      var increase = root.querySelector('[data-cult-qty-increase]');
      if (decrease) decrease.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (increase) increase.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    galleryThumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        setGalleryImage(i);
      });
    });

    galleryDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        setGalleryImage(i);
      });
    });

    if (galleryMain && galleryThumbs.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        var touchEndX = e.changedTouches[0].screenX;
        var touchEndY = e.changedTouches[0].screenY;
        var deltaX = touchEndX - touchStartX;
        var deltaY = touchEndY - touchStartY;
        if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          setGalleryImage(currentImageIndex + (deltaX < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (addButton && addButton.disabled) return;

        var formData = new FormData(form);
        var originalLabel = addButton.querySelector('[data-cult-add-label]').textContent;
        addButton.disabled = true;
        addButton.querySelector('[data-cult-add-label]').textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            addButton.querySelector('[data-cult-add-label]').textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            setTimeout(function () {
              addButton.disabled = false;
              addButton.querySelector('[data-cult-add-label]').textContent = originalLabel;
            }, 2200);
          })
          .catch(function (err) {
            addButton.disabled = false;
            addButton.querySelector('[data-cult-add-label]').textContent = originalLabel;
            var message = (err && err.description) || 'Could not add this item to your cart.';
            var errorEl = root.querySelector('[data-cult-form-error]');
            if (errorEl) {
              errorEl.textContent = message;
              errorEl.hidden = false;
            }
          });
      });
    }

    updateUI(initialVariant);
  }

  function initSpotlightSlider(root) {
    var slides = root.querySelectorAll('[data-cult-slide]');
    var dots = root.querySelectorAll('[data-cult-spotlight-dot]');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;

    function show(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }

    function next() { show(index + 1); }

    function start() {
      stop();
      timer = setInterval(next, 4500);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  }

  function initFaqAccordions(root) {
    root.querySelectorAll('[data-cult-faq-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-cult-faq-trigger]');
      var panel = item.querySelector('[data-cult-faq-panel]');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.hidden = !isOpen;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cult-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-cult-faq]').forEach(initFaqAccordions);
    document.querySelectorAll('[data-cult-spotlight-slider]').forEach(initSpotlightSlider);
  });
})();
